import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import AppBar from 'material-ui/AppBar';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';


class FormPersonalDetails extends Component {
    continue = e =>{
        e.preventDefault();
        this.props.nextStep();
    }
    back = e =>{
        e.preventDefault();
        this.props.prevStep();
    }

    render() { 
        const {values,handleChange}= this.props;
        return ( 
            <MuiThemeProvider>
                <React.Fragment>
                    <AppBar title="Enetr Personal Details"/>
                    <TextField
                       hintText="Enter Your Occupation"
                       floatingLabelText="Occupation"
                       onChange={handleChange('occupation')}
                       defalutValue={values.occupation}
                    />
                    <br/>
                    <TextField
                       hintText="Enter Your City"
                       floatingLabelText="City"
                       onChange={handleChange('city')}
                       defaultValue={values.city}
                    />
                    <br/>
                    <TextField
                       hintText="Enter Your Bio"
                       floatingLabelText="Bio"
                       onChange={handleChange('bio')}
                       defaultValue={values.bio}
                    />
                    <br/>
                    <RaisedButton
                        label="continue"
                        primary={true}
                        style={StyleSheet.button}
                        onClick={this.continue}
                    />
                    
                    <RaisedButton
                        label="back"
                        primary={false}
                        style={StyleSheet.button}
                        onClick={this.back}
                    />
                </React.Fragment>
            </MuiThemeProvider>
         )
    }
}

const styles={
      button:{
          margin:15
      }
}
 
export default FormPersonalDetails;